import React, { useState } from 'react';
import { 
  ChevronRight, ChevronDown, Folder, Layout, Box, Database, Plug, Zap, Sparkles, 
  Send, Plus, Eye, EyeOff, Upload, Download, Settings, GitBranch, Server, Cloud, 
  Lock, User, LogOut, Smartphone, Monitor, Tablet, Play, Code, Palette, Type, 
  Image, Square, Circle, Menu, X, Check, Search, Copy, Trash2, Edit3, Layers, 
  Grid, Move, MousePointer, Bell, Globe, Gift, Trophy, Star, CreditCard, 
  MessageCircle, Phone, Wifi, MapPin, QrCode, Shield, Users, BarChart3, 
  TrendingUp, Headphones, Home, Package, History, Gamepad2, Crown, Target, 
  Megaphone, Languages, FileText, PanelLeft, RefreshCw, AlertCircle, CheckCircle,
  Clock, ChevronLeft, ExternalLink, Bookmark, Heart, Share2, MoreHorizontal,
  ArrowRight, ArrowLeft, ArrowUp, ArrowDown, Maximize2, Minimize2
} from 'lucide-react';

// ==================== APP CONFIGURATION ====================

const appConfig = {
  name: 'Telco Self-Care',
  icon: '📱',
  primaryColor: '#0066cc',
  secondaryColor: '#00ccff',
  tagline: 'No-Code CX Builder Platform',
  version: '1.0.0'
};

// ==================== 41 SELFCARE SCREENS ====================

const selfcareScreens = {
  onboarding: [
    { id: 'splash', name: 'Splash Screen', icon: '🚀', description: 'App launch branding & animation', fields: 8 },
    { id: 'otp-verification', name: 'OTP Verification', icon: '🔐', description: 'MSISDN & OTP authentication', fields: 12 },
    { id: 'ciam-login', name: 'CIAM Login', icon: '👤', description: 'Customer identity management', fields: 15 },
    { id: 'quick-tour', name: 'Quick Tour', icon: '📖', description: 'Feature walkthrough carousel', fields: 6 },
    { id: 'permissions', name: 'Permissions', icon: '✅', description: 'Location, notifications, contacts', fields: 10 },
  ],
  home: [
    { id: 'home-prepaid', name: 'Home (Prepaid)', icon: '💳', description: 'Prepaid account dashboard', fields: 25 },
    { id: 'home-postpaid', name: 'Home (Postpaid)', icon: '📄', description: 'Postpaid account dashboard', fields: 28 },
    { id: 'linked-accounts', name: 'Linked Accounts', icon: '🔗', description: 'Multi-number management', fields: 18 },
    { id: 'account-switcher', name: 'Account Switcher', icon: '🔄', description: 'Switch between accounts', fields: 8 },
  ],
  bundles: [
    { id: 'bundles-catalog', name: 'Bundles Catalog', icon: '📦', description: 'Browse all available bundles', fields: 22 },
    { id: 'create-bundle', name: 'Create Your Bundle', icon: '🎨', description: 'Custom bundle builder', fields: 30 },
    { id: 'esim-management', name: 'eSIM Management', icon: '📲', description: 'eSIM activation & management', fields: 20 },
    { id: 'roaming', name: 'International Roaming', icon: '🌍', description: 'Roaming packages & settings', fields: 24 },
    { id: 'caller-tunes', name: 'Caller Tunes', icon: '🎵', description: 'Ringback tone selection', fields: 14 },
  ],
  recharge: [
    { id: 'recharge', name: 'Recharge/Top-up', icon: '💰', description: 'Main balance top-up', fields: 18 },
    { id: 'qr-voucher', name: 'QR & Voucher Top-up', icon: '📷', description: 'Scan QR or enter voucher', fields: 12 },
    { id: 'transactions', name: 'Historic Transactions', icon: '📋', description: 'Transaction history & details', fields: 16 },
  ],
  payments: [
    { id: 'payment-methods', name: 'Payment Methods', icon: '💳', description: 'Manage payment options', fields: 20 },
    { id: 'digital-wallet', name: 'Digital Wallet', icon: '👛', description: 'Wallet balance & management', fields: 15 },
    { id: 'saved-cards', name: 'Saved Cards', icon: '💳', description: 'Credit/Debit card management', fields: 18 },
    { id: 'net-banking', name: 'Net Banking', icon: '🏦', description: 'Bank transfer integration', fields: 14 },
    { id: 'pay-by-loyalty', name: 'Pay by Loyalty', icon: '⭐', description: 'Redeem points for payment', fields: 12 },
  ],
  gamification: [
    { id: 'daily-challenges', name: 'Daily Challenges', icon: '🎯', description: 'Complete tasks for rewards', fields: 20 },
    { id: 'leaderboard', name: 'Leaderboard', icon: '🏆', description: 'Rankings & competitions', fields: 15 },
    { id: 'gamification-rewards', name: 'Gamification Rewards', icon: '🎁', description: 'Claim earned rewards', fields: 18 },
  ],
  loyalty: [
    { id: 'loyalty-home', name: 'Loyalty Program', icon: '⭐', description: 'Points & tier status', fields: 22 },
    { id: 'partner-offers', name: 'Partner Offers', icon: '🤝', description: 'Third-party offers network', fields: 16 },
    { id: 'redeem-points', name: 'Redeem Points', icon: '🎁', description: 'Rewards catalog', fields: 20 },
  ],
  notifications: [
    { id: 'notifications-center', name: 'Notifications Center', icon: '🔔', description: 'All notifications', fields: 14 },
    { id: 'in-app-messages', name: 'In-App Messages', icon: '💬', description: 'Promotional messages', fields: 10 },
    { id: 'actionable-alerts', name: 'Actionable Alerts', icon: '⚡', description: 'Quick action notifications', fields: 12 },
  ],
  support: [
    { id: 'help-center', name: 'Help & Support', icon: '❓', description: 'FAQ & help articles', fields: 18 },
    { id: 'live-chat', name: 'Live Chat', icon: '💬', description: 'AI & human agent chat', fields: 20 },
    { id: 'store-locator', name: 'Store Locator', icon: '📍', description: 'Find nearby stores', fields: 16 },
  ],
  promotions: [
    { id: 'banners', name: 'Banners & Promotions', icon: '🖼️', description: 'Featured content banners', fields: 14 },
    { id: 'personalized-offers', name: 'For You', icon: '✨', description: 'Personalized recommendations', fields: 18 },
    { id: 'push-campaigns', name: 'Push Campaigns', icon: '📢', description: 'Push notification campaigns', fields: 16 },
  ],
  settings: [
    { id: 'main-menu', name: 'Menu', icon: '☰', description: 'Main navigation drawer', fields: 12 },
    { id: 'profile', name: 'My Profile', icon: '👤', description: 'Account settings', fields: 24 },
    { id: 'language', name: 'Multi-language', icon: '🌐', description: 'Language selection', fields: 8 },
    { id: 'global-search', name: 'Search', icon: '🔍', description: 'Global app search', fields: 10 },
  ],
};

// Category labels
const categoryLabels = {
  onboarding: '🚀 Onboarding',
  home: '🏠 Home',
  bundles: '📦 Bundles & Products',
  recharge: '💰 Recharge & Transactions',
  payments: '💳 Payments',
  gamification: '🎮 Gamification',
  loyalty: '⭐ Loyalty & Rewards',
  notifications: '🔔 Notifications',
  support: '🆘 Support',
  promotions: '📢 Promotions',
  settings: '⚙️ Settings',
};

// ==================== CMS CONTENT TYPES ====================

const cmsContentTypes = [
  { id: 'banners', name: 'Home Banners', icon: '🖼️', count: 15, status: 'active' },
  { id: 'promotions', name: 'Promotions', icon: '🎉', count: 24, status: 'active' },
  { id: 'offers', name: 'Special Offers', icon: '🎁', count: 32, status: 'active' },
  { id: 'bundles', name: 'Bundle Catalog', icon: '📦', count: 45, status: 'active' },
  { id: 'loyalty-rewards', name: 'Loyalty Rewards', icon: '⭐', count: 28, status: 'active' },
  { id: 'challenges', name: 'Daily Challenges', icon: '🎯', count: 15, status: 'active' },
  { id: 'faq', name: 'FAQ Articles', icon: '❓', count: 120, status: 'active' },
  { id: 'push-campaigns', name: 'Push Campaigns', icon: '📢', count: 8, status: 'scheduled' },
];

// ==================== SDK INTEGRATIONS ====================

const sdkIntegrations = [
  { id: 'firebase', name: 'Firebase Analytics', icon: '🔥', status: 'connected', metric: '250K events/day' },
  { id: 'crashlytics', name: 'Crashlytics', icon: '🐛', status: 'connected', metric: '99.95% crash-free' },
  { id: 'fcm', name: 'FCM Push', icon: '📬', status: 'connected', metric: '98.5% delivered' },
  { id: 'google-maps', name: 'Google Maps', icon: '🗺️', status: 'connected', metric: '40K calls/day' },
  { id: 'digital-kpis', name: 'Digital KPIs', icon: '📊', status: 'connected', metric: '45 metrics' },
  { id: 'ab-testing', name: 'A/B Testing', icon: '🧪', status: 'connected', metric: '12 experiments' },
  { id: 'deep-links', name: 'Deep Linking', icon: '🔗', status: 'connected', metric: '85K clicks/day' },
  { id: 'biometric', name: 'Biometric SDK', icon: '👆', status: 'connected', metric: '99.5% auth rate' },
];

// ==================== DATA CONNECTORS (TMForum APIs) ====================

const dataConnectors = [
  { id: 1, name: 'TMF629 Customer Management', icon: '👤', status: 'connected', type: 'tmforum', version: 'v4.0' },
  { id: 2, name: 'TMF632 Party Management', icon: '👥', status: 'connected', type: 'tmforum', version: 'v4.0' },
  { id: 3, name: 'TMF637 Product Inventory', icon: '📦', status: 'connected', type: 'tmforum', version: 'v4.0' },
  { id: 4, name: 'TMF666 Account Management', icon: '💰', status: 'connected', type: 'tmforum', version: 'v4.0' },
  { id: 5, name: 'TMF678 Customer Bill', icon: '🧾', status: 'connected', type: 'tmforum', version: 'v4.0' },
  { id: 6, name: 'TMF676 Payment Management', icon: '💳', status: 'connected', type: 'tmforum', version: 'v4.0' },
  { id: 7, name: 'BSS Billing System', icon: '📊', status: 'connected', type: 'oss-bss', version: 'v2.1' },
  { id: 8, name: 'OSS Inventory', icon: '📋', status: 'connected', type: 'oss-bss', version: 'v3.0' },
  { id: 9, name: 'CRM Platform', icon: '🎯', status: 'connected', type: 'crm', version: 'v5.2' },
  { id: 10, name: 'CIAM Identity', icon: '🔐', status: 'connected', type: 'identity', version: 'v2.0' },
  { id: 11, name: 'Loyalty Engine', icon: '⭐', status: 'connected', type: 'engagement', version: 'v1.5' },
  { id: 12, name: 'Gamification API', icon: '🎮', status: 'connected', type: 'engagement', version: 'v2.0' },
  { id: 13, name: 'CMS Headless', icon: '📝', status: 'connected', type: 'content', version: 'v3.1' },
  { id: 14, name: 'Notification Hub', icon: '🔔', status: 'connected', type: 'notifications', version: 'v2.2' },
  { id: 15, name: 'Payment Gateway', icon: '💳', status: 'connected', type: 'payments', version: 'v4.0' },
];

// ==================== DESIGN TOKENS ====================

const designTokens = {
  colors: [
    { name: 'Primary Blue', value: '#0066cc', category: 'brand' },
    { name: 'Secondary Blue', value: '#00ccff', category: 'brand' },
    { name: 'Dark Blue', value: '#004d99', category: 'brand' },
    { name: 'Accent Gold', value: '#ffcc00', category: 'brand' },
    { name: 'Prepaid Green', value: '#10b981', category: 'product' },
    { name: 'Postpaid Purple', value: '#8b5cf6', category: 'product' },
    { name: 'Success', value: '#22c55e', category: 'semantic' },
    { name: 'Warning', value: '#f59e0b', category: 'semantic' },
    { name: 'Error', value: '#ef4444', category: 'semantic' },
    { name: 'Info', value: '#3b82f6', category: 'semantic' },
  ],
  components: [
    { name: 'Balance Card', icon: CreditCard, category: 'dashboard' },
    { name: 'Usage Gauge', icon: Circle, category: 'dashboard' },
    { name: 'Bundle Card', icon: Package, category: 'catalog' },
    { name: 'Quick Action', icon: Zap, category: 'navigation' },
    { name: 'Offer Banner', icon: Megaphone, category: 'promotions' },
    { name: 'Transaction Row', icon: History, category: 'transactions' },
    { name: 'Loyalty Tier', icon: Crown, category: 'gamification' },
    { name: 'Challenge Card', icon: Target, category: 'gamification' },
    { name: 'Leaderboard Row', icon: Trophy, category: 'gamification' },
    { name: 'Reward Card', icon: Gift, category: 'loyalty' },
    { name: 'OTP Input', icon: Shield, category: 'authentication' },
    { name: 'QR Scanner', icon: QrCode, category: 'input' },
    { name: 'Map View', icon: MapPin, category: 'location' },
    { name: 'Chat Bubble', icon: MessageCircle, category: 'support' },
  ]
};

// ==================== SSO PROVIDERS ====================

const ssoProviders = [
  { id: 'google', name: 'Google Workspace', icon: '🔵', color: '#4285f4', users: '2.5B+' },
  { id: 'microsoft', name: 'Microsoft Entra', icon: '🟦', color: '#00a4ef', users: '1.4B+' },
  { id: 'okta', name: 'Okta', icon: '🔷', color: '#007dc1', users: '18K orgs' },
  { id: 'ping', name: 'PingIdentity', icon: '🔴', color: '#b91c1c', users: 'Enterprise' },
];

// ==================== INFRASTRUCTURE OPTIONS ====================

const infrastructureOptions = [
  { 
    id: 'aws', 
    name: 'AWS', 
    icon: '☁️', 
    color: '#ff9900',
    regions: [
      { id: 'us-east-1', name: 'US East (N. Virginia)', latency: '12ms' },
      { id: 'eu-west-1', name: 'Europe (Ireland)', latency: '18ms' },
      { id: 'ap-south-1', name: 'Asia Pacific (Mumbai)', latency: '25ms' },
      { id: 'me-south-1', name: 'Middle East (Bahrain)', latency: '15ms' },
      { id: 'af-south-1', name: 'Africa (Cape Town)', latency: '22ms' },
    ]
  },
  { 
    id: 'azure', 
    name: 'Azure', 
    icon: '🔷', 
    color: '#0078d4',
    regions: [
      { id: 'eastus', name: 'East US', latency: '14ms' },
      { id: 'westeurope', name: 'West Europe', latency: '16ms' },
      { id: 'centralindia', name: 'Central India', latency: '28ms' },
      { id: 'uaenorth', name: 'UAE North', latency: '12ms' },
    ]
  },
  { 
    id: 'gcp', 
    name: 'GCP', 
    icon: '🔵', 
    color: '#4285f4',
    regions: [
      { id: 'us-central1', name: 'US Central', latency: '15ms' },
      { id: 'europe-west1', name: 'Belgium', latency: '17ms' },
      { id: 'asia-south1', name: 'Mumbai', latency: '26ms' },
    ]
  },
  { 
    id: 'private', 
    name: 'Private Cloud', 
    icon: '🏢', 
    color: '#6b7280',
    regions: [
      { id: 'dc-primary', name: 'Primary DC', latency: '5ms' },
      { id: 'dc-secondary', name: 'Secondary DC', latency: '8ms' },
    ]
  },
];

// ==================== AI QUICK PROMPTS ====================

const aiQuickPrompts = [
  'Add OTP verification with resend timer and error handling',
  'Create prepaid balance card with recharge button',
  'Build circular data usage gauge with app breakdown',
  'Add gamification daily challenges with progress tracking',
  'Create loyalty points redemption catalog',
  'Build international roaming package selector',
  'Add eSIM activation flow with QR scanner',
  'Create AI-powered live chat with agent handoff',
  'Build promotional banner carousel with CTA',
  'Add family plan member management',
  'Create bundle comparison view with filters',
  'Build transaction history with search and export',
];

// ==================== DIGITAL KPIs ====================

const digitalKPIs = {
  engagement: [
    { name: 'DAU', value: '125K', change: '+12%', trend: 'up' },
    { name: 'MAU', value: '1.2M', change: '+8%', trend: 'up' },
    { name: 'Session Duration', value: '4.2 min', change: '+15%', trend: 'up' },
    { name: 'Sessions/User', value: '3.8', change: '+5%', trend: 'up' },
  ],
  conversion: [
    { name: 'Recharge Rate', value: '34%', change: '+3%', trend: 'up' },
    { name: 'Bundle Purchase', value: '28%', change: '+7%', trend: 'up' },
    { name: 'App Rating', value: '4.6', change: '+0.2', trend: 'up' },
    { name: 'NPS Score', value: '52', change: '+8', trend: 'up' },
  ],
  technical: [
    { name: 'Crash-Free Rate', value: '99.95%', change: '+0.1%', trend: 'up' },
    { name: 'API Latency', value: '124ms', change: '-12ms', trend: 'up' },
    { name: 'App Load Time', value: '1.8s', change: '-0.3s', trend: 'up' },
    { name: 'Push Delivery', value: '98.5%', change: '+1.2%', trend: 'up' },
  ],
};

// ==================== SCREEN PREVIEW COMPONENT ====================

const ScreenPreview = ({ screen, projectColor }) => {
  // Splash Screen
  if (screen.id === 'splash') {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: `linear-gradient(135deg, ${projectColor}, ${projectColor}aa)`, padding: '32px' }}>
        <div style={{ width: '80px', height: '80px', background: 'white', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.3)' }}>
          <span style={{ fontSize: '40px' }}>📱</span>
        </div>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: 'white', marginBottom: '8px' }}>My Telco</h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: '48px' }}>Self-Care App</p>
        <div style={{ width: '40px', height: '40px', border: '3px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      </div>
    );
  }

  // OTP Verification
  if (screen.id === 'otp-verification') {
    return (
      <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: `${projectColor}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <Shield size={32} color={projectColor} />
          </div>
          <h2 style={{ color: 'white', fontSize: '20px', fontWeight: '600', margin: '0 0 8px' }}>Verify Your Number</h2>
          <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>Enter the 6-digit code sent to</p>
          <p style={{ color: 'white', fontWeight: '500', margin: '4px 0 0' }}>+971 50 XXX X234</p>
        </div>
        
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} style={{ width: '44px', height: '52px', background: '#1e293b', border: i <= 3 ? `2px solid ${projectColor}` : '2px solid #334155', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: 'white' }}>
              {i <= 3 ? '•' : ''}
            </div>
          ))}
        </div>
        
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '8px' }}>Didn't receive the code?</p>
          <button style={{ color: projectColor, fontWeight: '500', background: 'none', border: 'none', cursor: 'pointer' }}>Resend in 0:45</button>
        </div>
        
        <button style={{ width: '100%', padding: '14px', borderRadius: '12px', background: projectColor, color: 'white', fontWeight: '600', fontSize: '16px', border: 'none', cursor: 'pointer' }}>
          Verify
        </button>
      </div>
    );
  }

  // Home Prepaid
  if (screen.id === 'home-prepaid') {
    return (
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>Good Morning</p>
            <h2 style={{ color: 'white', fontWeight: '600', margin: 0 }}>Ahmed Hassan</h2>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#334155', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              <Bell size={18} color="#9ca3af" />
              <span style={{ position: 'absolute', top: '-2px', right: '-2px', width: '16px', height: '16px', background: '#ef4444', borderRadius: '50%', fontSize: '10px', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>3</span>
            </div>
            <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#334155', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Search size={18} color="#9ca3af" />
            </div>
          </div>
        </div>
        
        {/* Balance Card */}
        <div style={{ borderRadius: '20px', padding: '20px', background: `linear-gradient(135deg, ${projectColor}, #0099ff)` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
            <div>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', margin: 0 }}>Main Balance</p>
              <h1 style={{ fontSize: '32px', fontWeight: 'bold', color: 'white', margin: '4px 0' }}>AED 125.50</h1>
              <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px', margin: 0 }}>Expires: 15 Jan 2026</p>
            </div>
            <span style={{ padding: '4px 12px', background: 'rgba(255,255,255,0.2)', borderRadius: '20px', fontSize: '12px', color: 'white' }}>Prepaid</span>
          </div>
          <button style={{ width: '100%', padding: '12px', background: 'white', borderRadius: '12px', border: 'none', fontWeight: '600', color: projectColor, cursor: 'pointer', fontSize: '15px' }}>
            💳 Recharge Now
          </button>
        </div>
        
        {/* Usage Gauges */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
          {[
            { label: 'Data', used: '5.7GB', total: '10GB', percent: 57, color: '#3b82f6' },
            { label: 'Voice', used: '128', total: '200 min', percent: 64, color: '#10b981' },
            { label: 'SMS', used: '45', total: '100', percent: 45, color: '#f59e0b' },
          ].map(usage => (
            <div key={usage.label} style={{ background: 'rgba(51,65,85,0.5)', borderRadius: '16px', padding: '16px', textAlign: 'center' }}>
              <div style={{ position: 'relative', width: '56px', height: '56px', margin: '0 auto 8px' }}>
                <svg width="56" height="56" style={{ transform: 'rotate(-90deg)' }}>
                  <circle cx="28" cy="28" r="24" stroke="#1e293b" strokeWidth="5" fill="none" />
                  <circle cx="28" cy="28" r="24" stroke={usage.color} strokeWidth="5" fill="none"
                    strokeDasharray={`${usage.percent * 1.51} 151`} strokeLinecap="round" />
                </svg>
                <span style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', color: 'white' }}>{usage.percent}%</span>
              </div>
              <p style={{ fontSize: '13px', color: '#9ca3af', margin: '0 0 2px' }}>{usage.label}</p>
              <p style={{ fontSize: '12px', color: 'white', margin: 0 }}>{usage.used}<span style={{ color: '#64748b' }}>/{usage.total}</span></p>
            </div>
          ))}
        </div>
        
        {/* Quick Actions */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
          {[
            { icon: '💰', label: 'Recharge' },
            { icon: '📦', label: 'Bundles' },
            { icon: '🌍', label: 'Roaming' },
            { icon: '🎁', label: 'Offers' },
          ].map((action, i) => (
            <button key={action.label} style={{ padding: '14px 8px', background: 'rgba(51,65,85,0.5)', borderRadius: '12px', border: 'none', textAlign: 'center', cursor: 'pointer' }}>
              <span style={{ fontSize: '24px', display: 'block', marginBottom: '4px' }}>{action.icon}</span>
              <span style={{ fontSize: '11px', color: '#d1d5db' }}>{action.label}</span>
            </button>
          ))}
        </div>
        
        {/* Loyalty Banner */}
        <div style={{ background: 'linear-gradient(90deg, rgba(234,179,8,0.2), rgba(249,115,22,0.2))', borderRadius: '16px', padding: '16px', display: 'flex', alignItems: 'center', gap: '12px', border: '1px solid rgba(234,179,8,0.3)' }}>
          <Trophy size={28} color="#eab308" />
          <div style={{ flex: 1 }}>
            <p style={{ color: 'white', fontWeight: '600', margin: 0 }}>Gold Member</p>
            <p style={{ fontSize: '14px', color: '#fbbf24', margin: 0 }}>2,450 points available</p>
          </div>
          <button style={{ padding: '6px 16px', background: 'rgba(234,179,8,0.3)', borderRadius: '8px', border: 'none', color: '#fbbf24', fontWeight: '500', cursor: 'pointer' }}>Redeem</button>
        </div>
      </div>
    );
  }

  // Bundles Catalog
  if (screen.id === 'bundles-catalog') {
    return (
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <ChevronLeft size={24} color="#9ca3af" />
          <h1 style={{ fontSize: '20px', fontWeight: '600', color: 'white', margin: 0 }}>📦 Bundles</h1>
        </div>
        
        <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '8px' }}>
          {['All', 'Data', 'Voice', 'Combo', 'Social'].map((cat, i) => (
            <button key={cat} style={{ padding: '8px 16px', borderRadius: '20px', whiteSpace: 'nowrap', background: i === 0 ? projectColor : 'rgba(51,65,85,0.5)', color: i === 0 ? 'white' : '#9ca3af', border: 'none', fontSize: '14px', cursor: 'pointer' }}>
              {cat}
            </button>
          ))}
        </div>
        
        {[
          { name: 'Super Data 10GB', desc: '10GB + Unlimited Social', price: 'AED 49', validity: '30 days', popular: true },
          { name: 'Flexi Combo', desc: '5GB + 100 min + 50 SMS', price: 'AED 35', validity: '30 days', popular: false },
          { name: 'Weekend Special', desc: '3GB Weekend Data', price: 'AED 15', validity: '2 days', popular: false },
        ].map((bundle, i) => (
          <div key={i} style={{ background: 'rgba(51,65,85,0.5)', borderRadius: '16px', padding: '16px', position: 'relative' }}>
            {bundle.popular && (
              <span style={{ position: 'absolute', top: '12px', right: '12px', padding: '4px 8px', background: '#f59e0b', borderRadius: '4px', fontSize: '10px', fontWeight: '600', color: 'white' }}>POPULAR</span>
            )}
            <h3 style={{ color: 'white', fontWeight: '600', margin: '0 0 4px' }}>{bundle.name}</h3>
            <p style={{ color: '#9ca3af', fontSize: '14px', margin: '0 0 12px' }}>{bundle.desc}</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontSize: '20px', fontWeight: 'bold', color: projectColor }}>{bundle.price}</span>
                <span style={{ color: '#64748b', fontSize: '12px', marginLeft: '8px' }}>{bundle.validity}</span>
              </div>
              <button style={{ padding: '8px 20px', background: projectColor, borderRadius: '8px', border: 'none', color: 'white', fontWeight: '500', cursor: 'pointer' }}>Buy</button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Daily Challenges
  if (screen.id === 'daily-challenges') {
    return (
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <ChevronLeft size={24} color="#9ca3af" />
          <h1 style={{ fontSize: '20px', fontWeight: '600', color: 'white', margin: 0 }}>🎯 Daily Challenges</h1>
        </div>
        
        <div style={{ background: 'linear-gradient(135deg, rgba(139,92,246,0.2), rgba(236,72,153,0.2))', borderRadius: '16px', padding: '20px', border: '1px solid rgba(139,92,246,0.3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ color: 'white', fontWeight: '500' }}>Today's Progress</span>
            <span style={{ color: '#a855f7', fontWeight: '600' }}>3/5 Complete</span>
          </div>
          <div style={{ height: '8px', background: 'rgba(139,92,246,0.2)', borderRadius: '4px', overflow: 'hidden' }}>
            <div style={{ width: '60%', height: '100%', background: 'linear-gradient(90deg, #a855f7, #ec4899)', borderRadius: '4px' }} />
          </div>
          <p style={{ color: '#9ca3af', fontSize: '12px', marginTop: '8px' }}>Complete 2 more challenges to earn bonus 50 points!</p>
        </div>
        
        {[
          { name: 'First Recharge of the Day', points: 25, done: true },
          { name: 'Share App with Friends', points: 50, done: true },
          { name: 'Rate Your Experience', points: 15, done: true },
          { name: 'Buy Any Bundle', points: 30, done: false },
          { name: 'Check Loyalty Rewards', points: 10, done: false },
        ].map((challenge, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px', borderRadius: '12px', background: challenge.done ? 'rgba(34,197,94,0.1)' : 'rgba(51,65,85,0.5)', border: challenge.done ? '1px solid rgba(34,197,94,0.3)' : '1px solid transparent' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: challenge.done ? '#22c55e' : '#334155', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {challenge.done ? <Check size={20} color="white" /> : <Target size={20} color="#64748b" />}
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ color: challenge.done ? '#22c55e' : 'white', fontWeight: '500', margin: 0 }}>{challenge.name}</p>
              <p style={{ color: '#fbbf24', fontSize: '12px', margin: '2px 0 0' }}>+{challenge.points} points</p>
            </div>
            {!challenge.done && <ChevronRight size={20} color="#64748b" />}
          </div>
        ))}
      </div>
    );
  }

  // Live Chat
  if (screen.id === 'live-chat') {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '16px', borderBottom: '1px solid #334155', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <ChevronLeft size={24} color="#9ca3af" />
          <div style={{ flex: 1 }}>
            <h2 style={{ color: 'white', fontSize: '16px', fontWeight: '600', margin: 0 }}>💬 Support Chat</h2>
            <p style={{ color: '#22c55e', fontSize: '12px', margin: 0 }}>● Online</p>
          </div>
          <MoreHorizontal size={20} color="#9ca3af" />
        </div>
        
        <div style={{ flex: 1, padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto' }}>
          <div style={{ alignSelf: 'flex-start', maxWidth: '80%' }}>
            <div style={{ background: '#334155', padding: '12px 16px', borderRadius: '16px 16px 16px 4px' }}>
              <p style={{ color: 'white', fontSize: '14px', margin: 0 }}>Hi! I'm your AI assistant. How can I help you today?</p>
            </div>
            <p style={{ color: '#64748b', fontSize: '11px', marginTop: '4px' }}>10:30 AM</p>
          </div>
          
          <div style={{ alignSelf: 'flex-end', maxWidth: '80%' }}>
            <div style={{ background: projectColor, padding: '12px 16px', borderRadius: '16px 16px 4px 16px' }}>
              <p style={{ color: 'white', fontSize: '14px', margin: 0 }}>I need help with my international roaming package</p>
            </div>
            <p style={{ color: '#64748b', fontSize: '11px', marginTop: '4px', textAlign: 'right' }}>10:31 AM</p>
          </div>
          
          <div style={{ alignSelf: 'flex-start', maxWidth: '80%' }}>
            <div style={{ background: '#334155', padding: '12px 16px', borderRadius: '16px 16px 16px 4px' }}>
              <p style={{ color: 'white', fontSize: '14px', margin: 0 }}>I'd be happy to help with roaming! Are you traveling soon? I can show you the best packages for your destination.</p>
            </div>
            <p style={{ color: '#64748b', fontSize: '11px', marginTop: '4px' }}>10:31 AM</p>
          </div>
        </div>
        
        <div style={{ padding: '12px 16px', borderTop: '1px solid #334155' }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button style={{ padding: '8px', background: '#334155', borderRadius: '50%', border: 'none', cursor: 'pointer' }}>
              <Plus size={20} color="#9ca3af" />
            </button>
            <input type="text" placeholder="Type your message..." style={{ flex: 1, background: '#334155', border: 'none', borderRadius: '20px', padding: '10px 16px', color: 'white', fontSize: '14px' }} />
            <button style={{ padding: '10px', background: projectColor, borderRadius: '50%', border: 'none', cursor: 'pointer' }}>
              <Send size={18} color="white" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Default Preview
  return (
    <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <span style={{ fontSize: '40px' }}>{screen.icon}</span>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: '600', color: 'white', margin: 0 }}>{screen.name}</h2>
          <p style={{ color: '#9ca3af', fontSize: '14px', margin: '4px 0 0' }}>{screen.description}</p>
        </div>
      </div>
      
      <div style={{ background: 'rgba(51,65,85,0.5)', borderRadius: '16px', padding: '32px', textAlign: 'center' }}>
        <Layout size={56} color="#475569" style={{ margin: '0 auto 16px' }} />
        <p style={{ color: '#9ca3af', margin: '0 0 4px' }}>Screen preview placeholder</p>
        <p style={{ fontSize: '14px', color: '#64748b', margin: 0 }}>Use AI Build to design this screen</p>
      </div>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
        <div style={{ padding: '16px', background: 'rgba(51,65,85,0.3)', borderRadius: '12px' }}>
          <p style={{ color: '#64748b', fontSize: '12px', margin: '0 0 4px' }}>Fields</p>
          <p style={{ color: 'white', fontWeight: '600', margin: 0 }}>{screen.fields || 15}</p>
        </div>
        <div style={{ padding: '16px', background: 'rgba(51,65,85,0.3)', borderRadius: '12px' }}>
          <p style={{ color: '#64748b', fontSize: '12px', margin: '0 0 4px' }}>Status</p>
          <p style={{ color: '#22c55e', fontWeight: '600', margin: 0 }}>Active</p>
        </div>
      </div>
    </div>
  );
};

// ==================== MAIN COMPONENT ====================

const CXBuilderTelco = () => {
  const [view, setView] = useState('login');
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState(['onboarding', 'home']);
  const [leftTab, setLeftTab] = useState('screens');
  const [rightTab, setRightTab] = useState('ai');
  const [devicePreview, setDevicePreview] = useState('mobile');
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [infrastructure, setInfrastructure] = useState('aws');
  const [selectedRegion, setSelectedRegion] = useState('me-south-1');
  const [showPassword, setShowPassword] = useState(false);

  const projectColor = appConfig.primaryColor;

  const toggleCategory = (category) => {
    setExpandedCategories(prev => 
      prev.includes(category) ? prev.filter(c => c !== category) : [...prev, category]
    );
  };

  // Count total screens
  const totalScreens = Object.values(selfcareScreens).flat().length;

  // Common styles
  const styles = {
    container: { height: '100vh', background: '#0f172a', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    header: { height: '56px', background: 'rgba(30,41,59,0.9)', backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(51,65,85,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px', flexShrink: 0 },
    main: { flex: 1, display: 'flex', overflow: 'hidden' },
    leftPanel: { width: '320px', background: 'rgba(30,41,59,0.5)', borderRight: '1px solid rgba(51,65,85,0.5)', display: 'flex', flexDirection: 'column', flexShrink: 0 },
    centerPanel: { flex: 1, display: 'flex', flexDirection: 'column', background: 'rgba(15,23,42,0.5)', overflow: 'hidden' },
    rightPanel: { width: '380px', background: 'rgba(30,41,59,0.5)', borderLeft: '1px solid rgba(51,65,85,0.5)', display: 'flex', flexDirection: 'column', flexShrink: 0 },
    tabBar: { display: 'flex', borderBottom: '1px solid rgba(51,65,85,0.5)' },
    tab: (active) => ({ flex: 1, padding: '14px 0', fontSize: '12px', fontWeight: '500', textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s', color: active ? 'white' : '#64748b', borderBottom: active ? `2px solid ${projectColor}` : '2px solid transparent', background: 'none', border: 'none' }),
    button: (bg, color) => ({ padding: '10px 20px', borderRadius: '10px', background: bg, color: color || 'white', border: 'none', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s' }),
  };

  // ========== LOGIN VIEW ==========
  if (view === 'login') {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px' }}>
        {/* Background decorations */}
        <div style={{ position: 'fixed', top: '10%', left: '10%', width: '300px', height: '300px', background: `${projectColor}20`, borderRadius: '50%', filter: 'blur(100px)' }} />
        <div style={{ position: 'fixed', bottom: '10%', right: '10%', width: '400px', height: '400px', background: '#7c3aed20', borderRadius: '50%', filter: 'blur(120px)' }} />
        
        <div style={{ position: 'relative', background: 'rgba(30,41,59,0.8)', backdropFilter: 'blur(24px)', borderRadius: '24px', padding: '48px', width: '100%', maxWidth: '440px', border: '1px solid rgba(51,65,85,0.5)', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}>
          {/* Logo & Title */}
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '72px', height: '72px', borderRadius: '20px', background: `linear-gradient(135deg, ${projectColor}, #00ccff)`, marginBottom: '20px', boxShadow: '0 10px 30px rgba(0,102,204,0.3)' }}>
              <Layers size={36} color="white" />
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: 'white', margin: '0 0 8px' }}>CX Builder</h1>
            <p style={{ color: '#9ca3af', margin: 0 }}>Telco Self-Care Platform</p>
          </div>
          
          {/* SSO Section */}
          <div style={{ marginBottom: '32px' }}>
            <p style={{ fontSize: '14px', color: '#64748b', textAlign: 'center', marginBottom: '20px' }}>Sign in with Enterprise SSO</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {ssoProviders.map(provider => (
                <button
                  key={provider.id}
                  onClick={() => setView('setup')}
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '14px 20px', borderRadius: '12px', background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', color: 'white', cursor: 'pointer', transition: 'all 0.2s', fontSize: '15px' }}
                  onMouseOver={(e) => e.currentTarget.style.background = 'rgba(51,65,85,0.8)'}
                  onMouseOut={(e) => e.currentTarget.style.background = 'rgba(51,65,85,0.5)'}
                >
                  <span style={{ fontSize: '22px' }}>{provider.icon}</span>
                  <span>Continue with {provider.name}</span>
                </button>
              ))}
            </div>
          </div>
          
          {/* Divider */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ flex: 1, height: '1px', background: 'rgba(71,85,105,0.5)' }} />
            <span style={{ color: '#64748b', fontSize: '14px' }}>or</span>
            <div style={{ flex: 1, height: '1px', background: 'rgba(71,85,105,0.5)' }} />
          </div>
          
          {/* Email/Password Form */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '14px', color: '#9ca3af', display: 'block', marginBottom: '8px' }}>Email</label>
              <input
                type="email"
                placeholder="admin@telco.com"
                style={{ width: '100%', background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', borderRadius: '10px', padding: '14px 16px', color: 'white', fontSize: '15px' }}
              />
            </div>
            <div>
              <label style={{ fontSize: '14px', color: '#9ca3af', display: 'block', marginBottom: '8px' }}>Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  style={{ width: '100%', background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', borderRadius: '10px', padding: '14px 16px', color: 'white', fontSize: '15px', paddingRight: '48px' }}
                />
                <button
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                >
                  {showPassword ? <EyeOff size={20} color="#64748b" /> : <Eye size={20} color="#64748b" />}
                </button>
              </div>
            </div>
          </div>
          
          <button
            onClick={() => setView('setup')}
            style={{ width: '100%', padding: '14px', borderRadius: '12px', background: `linear-gradient(135deg, ${projectColor}, #00ccff)`, color: 'white', fontWeight: '600', fontSize: '16px', border: 'none', cursor: 'pointer', marginBottom: '16px' }}
          >
            Sign In
          </button>
          
          <p style={{ fontSize: '12px', color: '#64748b', textAlign: 'center', margin: 0 }}>
            By signing in, you agree to our <a href="#" style={{ color: projectColor }}>Terms of Service</a> and <a href="#" style={{ color: projectColor }}>Privacy Policy</a>
          </p>
        </div>
      </div>
    );
  }

  // ========== SETUP VIEW ==========
  if (view === 'setup') {
    const selectedInfra = infrastructureOptions.find(i => i.id === infrastructure);
    
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)', padding: '32px' }}>
        {/* Background decorations */}
        <div style={{ position: 'fixed', top: '20%', right: '10%', width: '300px', height: '300px', background: `${projectColor}15`, borderRadius: '50%', filter: 'blur(100px)' }} />
        <div style={{ position: 'fixed', bottom: '20%', left: '10%', width: '350px', height: '350px', background: '#10b98115', borderRadius: '50%', filter: 'blur(100px)' }} />
        
        <div style={{ maxWidth: '1000px', margin: '0 auto', position: 'relative' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '40px' }}>
            <div style={{ padding: '14px', borderRadius: '16px', background: `linear-gradient(135deg, ${projectColor}, #00ccff)`, boxShadow: '0 10px 30px rgba(0,102,204,0.3)' }}>
              <Settings size={28} color="white" />
            </div>
            <div>
              <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: 'white', margin: 0 }}>Project Setup</h1>
              <p style={{ color: '#9ca3af', margin: '4px 0 0' }}>Configure your Telco Self-Care app infrastructure</p>
            </div>
          </div>
          
          {/* App Info Card */}
          <div style={{ background: 'rgba(30,41,59,0.6)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '28px', border: '1px solid rgba(51,65,85,0.5)', marginBottom: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
              <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: `${projectColor}20`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: '32px' }}>{appConfig.icon}</span>
              </div>
              <div>
                <h2 style={{ fontSize: '22px', fontWeight: '600', color: 'white', margin: 0 }}>{appConfig.name}</h2>
                <p style={{ color: '#9ca3af', margin: '4px 0 0' }}>{appConfig.tagline}</p>
              </div>
              <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                <p style={{ color: '#64748b', fontSize: '14px', margin: '0 0 4px' }}>Total Screens</p>
                <p style={{ color: 'white', fontSize: '28px', fontWeight: 'bold', margin: 0 }}>{totalScreens}</p>
              </div>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
              {[
                { label: 'Onboarding', count: selfcareScreens.onboarding.length, icon: '🚀' },
                { label: 'Home & Usage', count: selfcareScreens.home.length, icon: '🏠' },
                { label: 'Bundles', count: selfcareScreens.bundles.length, icon: '📦' },
                { label: 'Gamification', count: selfcareScreens.gamification.length, icon: '🎮' },
              ].map(item => (
                <div key={item.label} style={{ background: 'rgba(51,65,85,0.3)', borderRadius: '12px', padding: '16px', textAlign: 'center' }}>
                  <span style={{ fontSize: '24px' }}>{item.icon}</span>
                  <p style={{ color: 'white', fontWeight: '600', margin: '8px 0 2px' }}>{item.count}</p>
                  <p style={{ color: '#64748b', fontSize: '12px', margin: 0 }}>{item.label}</p>
                </div>
              ))}
            </div>
          </div>
          
          {/* Infrastructure Selection */}
          <div style={{ background: 'rgba(30,41,59,0.6)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '28px', border: '1px solid rgba(51,65,85,0.5)', marginBottom: '24px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Cloud size={22} color="#60a5fa" />
              Infrastructure
            </h2>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {infrastructureOptions.map(infra => (
                <button
                  key={infra.id}
                  onClick={() => { setInfrastructure(infra.id); setSelectedRegion(infra.regions[0].id); }}
                  style={{
                    padding: '20px',
                    borderRadius: '16px',
                    border: `2px solid ${infrastructure === infra.id ? infra.color : '#475569'}`,
                    background: infrastructure === infra.id ? `${infra.color}15` : 'rgba(51,65,85,0.3)',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  <span style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }}>{infra.icon}</span>
                  <div style={{ color: 'white', fontWeight: '600' }}>{infra.name}</div>
                  <div style={{ color: '#64748b', fontSize: '12px', marginTop: '4px' }}>{infra.regions.length} regions</div>
                </button>
              ))}
            </div>
            
            <div>
              <label style={{ fontSize: '14px', color: '#9ca3af', display: 'block', marginBottom: '10px' }}>Deployment Region</label>
              <select
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
                style={{ width: '100%', background: '#334155', border: '1px solid #475569', borderRadius: '12px', padding: '14px 16px', color: 'white', fontSize: '15px', cursor: 'pointer' }}
              >
                {selectedInfra?.regions.map(r => (
                  <option key={r.id} value={r.id}>{r.name} ({r.latency})</option>
                ))}
              </select>
            </div>
          </div>
          
          {/* Features Overview */}
          <div style={{ background: 'rgba(30,41,59,0.6)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '28px', border: '1px solid rgba(51,65,85,0.5)', marginBottom: '32px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'white', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Zap size={22} color="#f59e0b" />
              Features Overview
            </h2>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
              {[
                { title: 'TMForum APIs', desc: '6 standard APIs connected', icon: '🔌' },
                { title: 'Gamification', desc: 'Challenges & leaderboards', icon: '🎮' },
                { title: 'Loyalty Program', desc: 'Points & rewards system', icon: '⭐' },
                { title: 'eSIM Support', desc: 'Digital SIM activation', icon: '📲' },
                { title: 'AI Chat Support', desc: 'Intelligent assistance', icon: '💬' },
                { title: 'Multi-language', desc: '15+ languages supported', icon: '🌐' },
              ].map(feature => (
                <div key={feature.title} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '16px', background: 'rgba(51,65,85,0.3)', borderRadius: '12px' }}>
                  <span style={{ fontSize: '24px' }}>{feature.icon}</span>
                  <div>
                    <p style={{ color: 'white', fontWeight: '500', margin: '0 0 2px' }}>{feature.title}</p>
                    <p style={{ color: '#64748b', fontSize: '13px', margin: 0 }}>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Launch Button */}
          <button
            onClick={() => setView('builder')}
            style={{
              width: '100%',
              padding: '18px',
              borderRadius: '14px',
              background: `linear-gradient(135deg, ${projectColor}, #00ccff)`,
              color: 'white',
              fontWeight: '600',
              fontSize: '17px',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              boxShadow: '0 10px 30px rgba(0,102,204,0.3)'
            }}
          >
            Launch CX Builder <ArrowRight size={20} />
          </button>
        </div>
      </div>
    );
  }

  // ========== BUILDER VIEW ==========
  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ padding: '8px', borderRadius: '10px', background: `linear-gradient(135deg, ${projectColor}, #00ccff)` }}>
              <Layers size={22} color="white" />
            </div>
            <span style={{ fontWeight: 'bold', color: 'white', fontSize: '17px' }}>CX Builder</span>
          </div>
          
          <div style={{ height: '28px', width: '1px', background: '#334155' }} />
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 14px', background: `${projectColor}20`, borderRadius: '10px', border: `1px solid ${projectColor}40` }}>
            <span style={{ fontSize: '22px' }}>{appConfig.icon}</span>
            <div>
              <span style={{ fontWeight: '600', color: 'white' }}>{appConfig.name}</span>
              <span style={{ marginLeft: '8px', padding: '2px 8px', background: '#10b98120', color: '#34d399', borderRadius: '4px', fontSize: '11px' }}>{totalScreens} screens</span>
            </div>
          </div>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <select style={{ background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', borderRadius: '8px', padding: '8px 12px', fontSize: '14px', color: 'white', cursor: 'pointer' }}>
            <option>🇺🇸 English</option>
            <option>🇸🇦 العربية</option>
            <option>🇫🇷 Français</option>
            <option>🇮🇳 हिंदी</option>
          </select>
          
          <button style={{ padding: '8px', borderRadius: '8px', background: 'none', border: 'none', cursor: 'pointer', position: 'relative' }}>
            <Bell size={20} color="#9ca3af" />
            <span style={{ position: 'absolute', top: '4px', right: '4px', width: '8px', height: '8px', background: '#ef4444', borderRadius: '50%' }} />
          </button>
          
          <button style={{ padding: '8px', borderRadius: '8px', background: 'none', border: 'none', cursor: 'pointer' }}>
            <Settings size={20} color="#9ca3af" />
          </button>
          
          <button onClick={() => setShowPublishModal(true)} style={{ ...styles.button(`linear-gradient(135deg, ${projectColor}, #00ccff)`), padding: '10px 20px' }}>
            <Play size={16} /> Publish
          </button>
          
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: `linear-gradient(135deg, ${projectColor}, #a855f7)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px', fontWeight: '600' }}>
            PM
          </div>
        </div>
      </header>
      
      {/* Main Content */}
      <div style={styles.main}>
        {/* Left Panel */}
        <div style={styles.leftPanel}>
          <div style={styles.tabBar}>
            {[
              { id: 'screens', icon: Layout, label: 'Screens' },
              { id: 'elements', icon: Box, label: 'Elements' },
              { id: 'connectors', icon: Plug, label: 'APIs' },
              { id: 'sdks', icon: Database, label: 'SDKs' },
            ].map(tab => (
              <button key={tab.id} onClick={() => setLeftTab(tab.id)} style={styles.tab(leftTab === tab.id)}>
                <tab.icon size={16} style={{ margin: '0 auto 4px' }} />
                {tab.label}
              </button>
            ))}
          </div>
          
          <div style={{ flex: 1, overflow: 'auto', padding: '12px' }}>
            {leftTab === 'screens' && (
              <div>
                {Object.entries(selfcareScreens).map(([category, screenList]) => (
                  <div key={category} style={{ marginBottom: '4px' }}>
                    <button
                      onClick={() => toggleCategory(category)}
                      style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: '8px', background: 'none', border: 'none', cursor: 'pointer', transition: 'all 0.2s' }}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {expandedCategories.includes(category) ? <ChevronDown size={14} color="#64748b" /> : <ChevronRight size={14} color="#64748b" />}
                        <span style={{ fontSize: '14px', fontWeight: '500', color: '#d1d5db' }}>{categoryLabels[category]}</span>
                      </span>
                      <span style={{ fontSize: '12px', color: '#64748b', background: 'rgba(51,65,85,0.5)', padding: '2px 8px', borderRadius: '4px' }}>{screenList.length}</span>
                    </button>
                    
                    {expandedCategories.includes(category) && (
                      <div style={{ marginLeft: '16px' }}>
                        {screenList.map(screen => (
                          <button
                            key={screen.id}
                            onClick={() => setSelectedScreen(screen)}
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              padding: '10px 12px',
                              borderRadius: '8px',
                              textAlign: 'left',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              background: selectedScreen?.id === screen.id ? `${projectColor}20` : 'transparent',
                              borderLeft: selectedScreen?.id === screen.id ? `3px solid ${projectColor}` : '3px solid transparent',
                              color: selectedScreen?.id === screen.id ? 'white' : '#9ca3af',
                              border: 'none'
                            }}
                          >
                            <span style={{ fontSize: '18px' }}>{screen.icon}</span>
                            <span style={{ fontSize: '14px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{screen.name}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
            
            {leftTab === 'elements' && (
              <div>
                <div style={{ marginBottom: '20px' }}>
                  <h3 style={{ fontSize: '12px', fontWeight: '600', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px', padding: '0 8px' }}>Brand Colors</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
                    {designTokens.colors.map(color => (
                      <div key={color.name} style={{ cursor: 'pointer' }} title={color.name}>
                        <div style={{ width: '100%', aspectRatio: '1', borderRadius: '8px', border: '2px solid rgba(71,85,105,0.5)', background: color.value, transition: 'transform 0.2s' }} />
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h3 style={{ fontSize: '12px', fontWeight: '600', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px', padding: '0 8px' }}>Components</h3>
                  {designTokens.components.map(comp => (
                    <div
                      key={comp.name}
                      style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', cursor: 'move', transition: 'all 0.2s', marginBottom: '4px' }}
                      draggable
                    >
                      <comp.icon size={18} color={projectColor} />
                      <span style={{ fontSize: '14px', color: '#d1d5db' }}>{comp.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {leftTab === 'connectors' && (
              <div>
                <p style={{ fontSize: '12px', color: '#64748b', padding: '0 8px', marginBottom: '12px' }}>TMForum & Enterprise APIs</p>
                {dataConnectors.map(connector => (
                  <div key={connector.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: '8px', transition: 'all 0.2s', marginBottom: '4px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <span style={{ fontSize: '20px' }}>{connector.icon}</span>
                      <div>
                        <div style={{ fontSize: '14px', color: '#d1d5db' }}>{connector.name}</div>
                        {connector.version && <div style={{ fontSize: '12px', color: '#64748b' }}>{connector.version}</div>}
                      </div>
                    </div>
                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: connector.status === 'connected' ? '#34d399' : '#64748b' }} />
                  </div>
                ))}
              </div>
            )}
            
            {leftTab === 'sdks' && (
              <div>
                <p style={{ fontSize: '12px', color: '#64748b', padding: '0 8px', marginBottom: '12px' }}>SDK Integrations</p>
                {sdkIntegrations.map(sdk => (
                  <div key={sdk.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: '8px', transition: 'all 0.2s', marginBottom: '4px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <span style={{ fontSize: '20px' }}>{sdk.icon}</span>
                      <div>
                        <div style={{ fontSize: '14px', color: '#d1d5db' }}>{sdk.name}</div>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>{sdk.metric}</div>
                      </div>
                    </div>
                    <span style={{ padding: '3px 10px', borderRadius: '6px', fontSize: '12px', background: sdk.status === 'connected' ? 'rgba(34,197,94,0.2)' : 'rgba(100,116,139,0.2)', color: sdk.status === 'connected' ? '#34d399' : '#9ca3af' }}>
                      {sdk.status}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        
        {/* Center Panel - Device Preview */}
        <div style={styles.centerPanel}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '14px', borderBottom: '1px solid rgba(51,65,85,0.5)' }}>
            {[
              { id: 'mobile', icon: Smartphone, label: 'Mobile' },
              { id: 'tablet', icon: Tablet, label: 'Tablet' },
              { id: 'desktop', icon: Monitor, label: 'Desktop' },
            ].map(device => (
              <button
                key={device.id}
                onClick={() => setDevicePreview(device.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 18px',
                  borderRadius: '10px',
                  background: devicePreview === device.id ? `${projectColor}20` : 'transparent',
                  border: 'none',
                  color: devicePreview === device.id ? 'white' : '#64748b',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                <device.icon size={18} />
                <span style={{ fontSize: '14px' }}>{device.label}</span>
              </button>
            ))}
          </div>
          
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px', overflow: 'auto' }}>
            <div
              style={{
                background: '#020617',
                borderRadius: devicePreview === 'mobile' ? '40px' : '24px',
                boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
                overflow: 'hidden',
                transition: 'all 0.3s',
                width: devicePreview === 'mobile' ? '375px' : devicePreview === 'tablet' ? '768px' : '100%',
                maxWidth: devicePreview === 'desktop' ? '1200px' : undefined,
                height: devicePreview === 'mobile' ? '780px' : devicePreview === 'tablet' ? '560px' : '620px',
                border: devicePreview === 'mobile' ? '8px solid #1e293b' : '4px solid #1e293b',
              }}
            >
              {/* Phone Notch */}
              {devicePreview === 'mobile' && (
                <div style={{ height: '36px', background: '#020617', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ width: '140px', height: '28px', background: 'black', borderRadius: '0 0 20px 20px' }} />
                </div>
              )}
              
              <div style={{ height: devicePreview === 'mobile' ? 'calc(100% - 36px)' : '100%', background: '#0f172a', overflow: 'auto' }}>
                {selectedScreen ? (
                  <ScreenPreview screen={selectedScreen} projectColor={projectColor} />
                ) : (
                  <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#64748b', padding: '32px' }}>
                    <Layout size={64} style={{ marginBottom: '20px', opacity: 0.3 }} />
                    <p style={{ fontSize: '18px', marginBottom: '8px' }}>Select a screen to preview</p>
                    <p style={{ fontSize: '14px', color: '#475569' }}>Choose from {totalScreens} available screens</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {/* Bottom Navigation Preview */}
          {devicePreview === 'mobile' && selectedScreen && (
            <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
              <div style={{ display: 'flex', gap: '4px', background: '#1e293b', borderRadius: '9999px', padding: '6px' }}>
                <button style={{ padding: '12px', borderRadius: '9999px', background: `${projectColor}20`, border: 'none', color: projectColor, cursor: 'pointer' }}><Home size={22} /></button>
                <button style={{ padding: '12px', borderRadius: '9999px', background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }}><Package size={22} /></button>
                <button style={{ padding: '12px', borderRadius: '9999px', background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }}><Gamepad2 size={22} /></button>
                <button style={{ padding: '12px', borderRadius: '9999px', background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }}><Crown size={22} /></button>
                <button style={{ padding: '12px', borderRadius: '9999px', background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }}><Menu size={22} /></button>
              </div>
            </div>
          )}
        </div>
        
        {/* Right Panel */}
        <div style={styles.rightPanel}>
          <div style={styles.tabBar}>
            {[
              { id: 'ai', icon: Sparkles, label: 'AI Build' },
              { id: 'manual', icon: Edit3, label: 'Manual' },
              { id: 'cms', icon: FileText, label: 'CMS' },
              { id: 'kpis', icon: BarChart3, label: 'KPIs' },
            ].map(tab => (
              <button key={tab.id} onClick={() => setRightTab(tab.id)} style={styles.tab(rightTab === tab.id)}>
                <tab.icon size={16} style={{ margin: '0 auto 4px' }} />
                {tab.label}
              </button>
            ))}
          </div>
          
          <div style={{ flex: 1, overflow: 'auto', padding: '16px' }}>
            {rightTab === 'ai' && (
              <div>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '500', color: '#d1d5db', display: 'block', marginBottom: '10px' }}>Describe what you want to build</label>
                  <textarea
                    style={{ width: '100%', height: '100px', background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', borderRadius: '12px', padding: '14px 16px', color: 'white', resize: 'none', fontSize: '14px', lineHeight: '1.5' }}
                    placeholder="E.g., Add a circular data usage gauge with breakdown by app, showing Data, Voice, and SMS consumption..."
                  />
                  <button style={{ width: '100%', marginTop: '12px', padding: '12px', borderRadius: '10px', background: `linear-gradient(135deg, ${projectColor}, #00ccff)`, color: 'white', fontWeight: '600', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <Sparkles size={18} /> Generate with AI
                  </button>
                </div>
                
                <div>
                  <h3 style={{ fontSize: '14px', fontWeight: '500', color: '#9ca3af', marginBottom: '14px' }}>Quick Prompts</h3>
                  {aiQuickPrompts.map((prompt, i) => (
                    <button
                      key={i}
                      style={{ width: '100%', textAlign: 'left', padding: '10px 14px', borderRadius: '10px', background: 'rgba(51,65,85,0.3)', border: 'none', fontSize: '13px', color: '#d1d5db', marginBottom: '8px', cursor: 'pointer', transition: 'all 0.2s', lineHeight: '1.4' }}
                    >
                      {prompt}
                    </button>
                  ))}
                </div>
              </div>
            )}
            
            {rightTab === 'cms' && (
              <div>
                <p style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '16px' }}>Business users can manage content:</p>
                {cmsContentTypes.map(content => (
                  <div
                    key={content.id}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px', borderRadius: '12px', background: 'rgba(51,65,85,0.3)', marginBottom: '10px', cursor: 'pointer', transition: 'all 0.2s' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <span style={{ fontSize: '22px' }}>{content.icon}</span>
                      <div>
                        <div style={{ fontSize: '14px', color: 'white' }}>{content.name}</div>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>{content.count} items</div>
                      </div>
                    </div>
                    <span style={{ padding: '4px 10px', borderRadius: '6px', fontSize: '12px', background: content.status === 'active' ? 'rgba(34,197,94,0.2)' : 'rgba(234,179,8,0.2)', color: content.status === 'active' ? '#34d399' : '#fbbf24' }}>
                      {content.status}
                    </span>
                  </div>
                ))}
              </div>
            )}
            
            {rightTab === 'kpis' && (
              <div>
                <h3 style={{ fontSize: '14px', fontWeight: '500', color: '#d1d5db', marginBottom: '16px' }}>📊 Digital KPIs</h3>
                
                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '12px', color: '#64748b', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Engagement</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                    {digitalKPIs.engagement.map(kpi => (
                      <div key={kpi.name} style={{ padding: '14px', borderRadius: '10px', background: 'rgba(51,65,85,0.3)' }}>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>{kpi.name}</div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'white' }}>{kpi.value}</div>
                        <div style={{ fontSize: '12px', color: '#34d399' }}>{kpi.change}</div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '12px', color: '#64748b', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Conversion</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                    {digitalKPIs.conversion.map(kpi => (
                      <div key={kpi.name} style={{ padding: '14px', borderRadius: '10px', background: 'rgba(51,65,85,0.3)' }}>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>{kpi.name}</div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'white' }}>{kpi.value}</div>
                        <div style={{ fontSize: '12px', color: '#34d399' }}>{kpi.change}</div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 style={{ fontSize: '12px', color: '#64748b', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Technical</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                    {digitalKPIs.technical.map(kpi => (
                      <div key={kpi.name} style={{ padding: '14px', borderRadius: '10px', background: 'rgba(51,65,85,0.3)' }}>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>{kpi.name}</div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'white' }}>{kpi.value}</div>
                        <div style={{ fontSize: '12px', color: '#34d399' }}>{kpi.change}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            
            {rightTab === 'manual' && (
              <div>
                <p style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '16px' }}>
                  {selectedScreen ? `Edit ${selectedScreen.name}` : 'Select a screen to edit'}
                </p>
                
                {selectedScreen && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                      <label style={{ fontSize: '13px', color: '#9ca3af', display: 'block', marginBottom: '8px' }}>Screen Name</label>
                      <input
                        type="text"
                        defaultValue={selectedScreen.name}
                        style={{ width: '100%', background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', borderRadius: '10px', padding: '12px 14px', color: 'white', fontSize: '14px' }}
                      />
                    </div>
                    
                    <div>
                      <label style={{ fontSize: '13px', color: '#9ca3af', display: 'block', marginBottom: '8px' }}>Description</label>
                      <textarea
                        defaultValue={selectedScreen.description}
                        style={{ width: '100%', height: '80px', background: 'rgba(51,65,85,0.5)', border: '1px solid rgba(71,85,105,0.5)', borderRadius: '10px', padding: '12px 14px', color: 'white', fontSize: '14px', resize: 'none' }}
                      />
                    </div>
                    
                    <div>
                      <label style={{ fontSize: '13px', color: '#9ca3af', display: 'block', marginBottom: '8px' }}>Screen Icon</label>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        {['🚀', '🏠', '📦', '💰', '💳', '🎮', '⭐', '🔔', '❓', '📢'].map(icon => (
                          <button
                            key={icon}
                            style={{
                              width: '44px',
                              height: '44px',
                              borderRadius: '10px',
                              background: selectedScreen.icon === icon ? `${projectColor}30` : 'rgba(51,65,85,0.3)',
                              border: selectedScreen.icon === icon ? `2px solid ${projectColor}` : '2px solid transparent',
                              fontSize: '20px',
                              cursor: 'pointer'
                            }}
                          >
                            {icon}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    <button style={{ width: '100%', padding: '12px', borderRadius: '10px', background: projectColor, color: 'white', fontWeight: '600', border: 'none', cursor: 'pointer' }}>
                      Save Changes
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Publish Modal */}
      {showPublishModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
          <div style={{ background: '#1e293b', borderRadius: '24px', padding: '40px', maxWidth: '420px', width: '100%', margin: '16px', textAlign: 'center', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}>
            <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'linear-gradient(135deg, rgba(34,197,94,0.2), rgba(16,185,129,0.2))', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <Check size={36} color="#22c55e" />
            </div>
            <h2 style={{ fontSize: '26px', fontWeight: 'bold', color: 'white', margin: '0 0 10px' }}>Published Successfully!</h2>
            <p style={{ color: '#9ca3af', marginBottom: '28px' }}>Your Telco Self-Care app is now live</p>
            
            <div style={{ marginBottom: '28px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="#" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '14px', background: 'rgba(59,130,246,0.1)', borderRadius: '12px', color: '#60a5fa', textDecoration: 'none', fontWeight: '500' }}>
                📱 iOS App Store <ExternalLink size={16} />
              </a>
              <a href="#" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '14px', background: 'rgba(34,197,94,0.1)', borderRadius: '12px', color: '#34d399', textDecoration: 'none', fontWeight: '500' }}>
                🤖 Google Play Store <ExternalLink size={16} />
              </a>
              <a href="#" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '14px', background: 'rgba(239,68,68,0.1)', borderRadius: '12px', color: '#f87171', textDecoration: 'none', fontWeight: '500' }}>
                📲 Huawei AppGallery <ExternalLink size={16} />
              </a>
            </div>
            
            <button
              onClick={() => setShowPublishModal(false)}
              style={{ width: '100%', padding: '14px', borderRadius: '12px', background: `linear-gradient(135deg, ${projectColor}, #00ccff)`, color: 'white', fontWeight: '600', border: 'none', cursor: 'pointer', fontSize: '16px' }}
            >
              Continue Building
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CXBuilderTelco;
